import React from 'react';
import { useState, useEffect, useRef } from 'react';
import api from '../service/api';
import { DataTable } from '../components/datatable/DataTable';
import { Column } from 'primereact/column';
import { Toast } from '../components/toast/Toast';
import { Toolbar } from '../components/toolbar/Toolbar';
import { Dialog } from '../components/dialog/Dialog';
import { InputText } from '../components/inputtext/InputText';
import classNames from 'classnames';
import { Button } from '../components/button/Button';
import { Badge } from '../components/badge/Badge';
import { ChromePicker, SketchPicker } from 'react-color';

export const TipoExecutor = () => {

    let emptyTipoExecutor = {
        idtipoexecutor: null,
        tipoexecutor: '',
        cor: '#30a2c0',
    };

    const [tipoexecutor, setTipoExecutor] = useState(emptyTipoExecutor);
    const [listaTipoExecutor, setListaTipoExecutor] = useState(null);
    const [tipoexecutorDialog, setTipoExecutorDialog] = useState(false);
    const [deleteTipoExecutorDialog, setDeleteTipoExecutorDialog] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);

    useEffect(() => {
        api.get(`/tipoexecutor`).then((res) => {
            setListaTipoExecutor(res.data);
        });
    }, []);

    const openNew = () => {
        setTipoExecutor(emptyTipoExecutor);
        setSubmitted(false);
        setTipoExecutorDialog(true);
    }

    const saveTipoExecutor = () => {
        setSubmitted(true);
        if (tipoexecutor.tipoexecutor.trim()) {
            let _listaTipoExecutor = [...listaTipoExecutor];
            let _tipoexecutor = { ...tipoexecutor };
            if (_tipoexecutor.idtipoexecutor) {
                const index = findIndexById(_tipoexecutor.idtipoexecutor);
                api.put('/tipoexecutor', _tipoexecutor).then(res => {
                    if (res.status === 200) {
                        _listaTipoExecutor[index] = _tipoexecutor;
                        setListaTipoExecutor(_listaTipoExecutor);
                        toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Registro atualizado', life: 3000 });
                    }
                })
                    .catch(error => {
                        toast.current.show({ severity: 'error', summary: 'Erro', detail: 'O sistema não conseguiu atualizar o registro', life: 3000 });
                        console.log(error);
                    })
            }
            else {
                _tipoexecutor.idtipoexecutor = 0;
                api.post('/tipoexecutor', _tipoexecutor).then(res => {
                    if (res.status === 200) {
                        _tipoexecutor.idtipoexecutor = res.data.id;
                        _listaTipoExecutor.push(_tipoexecutor);
                        setListaTipoExecutor(_listaTipoExecutor);
                        toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Registro inserido', life: 3000 });
                    }
                })
                    .catch(error => {
                        toast.current.show({ severity: 'error', summary: 'Erro', detail: 'O sistema não conseguiu inserir o registro', life: 3000 });
                        console.log(error);
                    })
            }
            // setListaTipoExecutor(_listaTipoExecutor);
            setTipoExecutorDialog(false);
            setTipoExecutor(emptyTipoExecutor);
        }
    }

    const editTipoExecutor = (tipoexecutor) => {
        setTipoExecutor({ ...tipoexecutor });
        setTipoExecutorDialog(true);
    }

    const deleteTipoExecutor = () => {
        api.delete(`/tipoexecutor/${tipoexecutor.idtipoexecutor}`).then(res => {
            if (res.status === 200) {
                let _tipoexecutor = listaTipoExecutor.filter(val => val.idtipoexecutor !== tipoexecutor.idtipoexecutor);
                setListaTipoExecutor(_tipoexecutor);
                setDeleteTipoExecutorDialog(false);
                setTipoExecutor(emptyTipoExecutor);
                toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Registro excluído', life: 3000 });
            }
        })
            .catch(error => {
                toast.current.show({ severity: 'error', summary: 'Erro', detail: 'O sistema não conseguiu excluir o registro', life: 3000 });
                console.log(error);
            })
    }

    const confirmDeleteTipoExecutor = (tipoexecutor) => {
        setTipoExecutor(tipoexecutor);
        setDeleteTipoExecutorDialog(true);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setTipoExecutorDialog(false);
    }

    const hideDeleteTipoExecutorDialog = () => {
        setDeleteTipoExecutorDialog(false);
    }

    const findIndexById = (n) => {
        let index = -1;
        for (let i = 0; i < listaTipoExecutor.length; i++) {
            if (listaTipoExecutor[i].idtipoexecutor === n) {
                index = i;
                break;
            }
        }
        return index;
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _tipoexecutor = { ...tipoexecutor };
        _tipoexecutor[`${name}`] = val;
        setTipoExecutor(_tipoexecutor);
    }

    const handleChangeComplete = (color) => {
        let _tipoexecutor = { ...tipoexecutor };
        _tipoexecutor.cor = color.hex;
        setTipoExecutor(_tipoexecutor);
      };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Novo" icon="pi pi-plus" className="p-button-primary p-mr-2" onClick={openNew} />
            </React.Fragment>
        )
    }

    const exportExcel = () => {
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(listaTipoExecutor);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            saveAsExcelFile(excelBuffer, 'listaTipoExecutor');
        });
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
        });
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportExcel} />
            </React.Fragment>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button p-button-primary p-mr-2" onClick={() => editTipoExecutor(rowData)} />
                <Button icon="pi pi-trash" className="p-button p-button-danger" onClick={() => confirmDeleteTipoExecutor(rowData)} />
            </div>
        );
    }

    const corTemplate = (rowData) => {
        return (<Badge className="product-badge" size="large" style={{ background: `${rowData.cor}` }} ></Badge>);
    }

    const header = (
        <div className="table-header">
            <h5 className="p-m-0 p-text-bold">Tipo de Executor</h5>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Procurar..." />
            </span>
        </div>
    );

    const tipoexecutorDialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Salvar" icon="pi pi-check" className="p-button-text" onClick={saveTipoExecutor} />
        </>
    );

    const deleteTipoExecutorDialogFooter = (
        <>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteTipoExecutorDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteTipoExecutor} />
        </>
    );

    return (
        <div className="p-grid crud-demo">
            <div className="p-col-12">
                <div className="card">

                    <Toast ref={toast} />
                    <Toolbar className="p-mb-4" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                    <DataTable
                        ref={dt} value={listaTipoExecutor} dataKey="idtipoexecutor"
                        paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Exibindo de {first} a {last} de {totalRecords} Tipos de Executor" globalFilter={globalFilter}
                        emptyMessage="Nenhum Tipo de Executor encontrado." header={header}>
                        <Column field="idtipoexecutor" header="Id" sortable style={{ width: '6%' }} />
                        <Column field="tipoexecutor" header="Descrição" sortable ></Column>
                        <Column field="cor" header="Cor" body={corTemplate} className="p-text-center" style={{ width: '6%' }} ></Column>
                        <Column body={actionBodyTemplate} className="p-text-center" style={{ width: '12%' }}></Column>
                    </DataTable>
                    <Dialog visible={tipoexecutorDialog} style={{ width: '450px' }} header="Tipo de Executor" modal className="p-fluid" footer={tipoexecutorDialogFooter} onHide={hideDialog}>
                        <div className="p-field">
                            <label htmlFor="tipoexecutor">Descrição</label>
                            <InputText id="tipoexecutor" value={tipoexecutor.tipoexecutor} onChange={(e) => onInputChange(e, 'tipoexecutor')} required autoFocus className={classNames({ 'p-invalid': submitted && !tipoexecutor.tipoexecutor })} />
                            {submitted && !tipoexecutor.tipoexecutor && <small className="p-invalid">Descrição é requerido.</small>}
                        </div>
                        <div className="p-field">
                            <label htmlFor="cor">Cor</label>
                            {/* <InputText id="cor" value={tipoexecutor.cor} onChange={(e) => onInputChange(e, 'cor')} required className={classNames({ 'p-invalid': submitted && !tipoexecutor.cor })} />
                            {submitted && !tipoexecutor.cor && <small className="p-invalid">Cor é requerido.</small>} */}
                                <ChromePicker id="corhexa"
                            disableAlpha  
                            color={tipoexecutor.cor}
                            onChangeComplete={handleChangeComplete}
                            />
                        </div>
                    </Dialog>
                    <Dialog visible={deleteTipoExecutorDialog} style={{ width: '450px' }} header="Confirmação" modal footer={deleteTipoExecutorDialogFooter} onHide={hideDeleteTipoExecutorDialog}>
                        <div className="confirmation-content">
                            <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                            {tipoexecutor && <span>Tem certeza que deseja excluir <b>{tipoexecutor.tipoexecutor}</b>?</span>}
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    );
}
